import { z } from 'zod'

const BadgeSchema = z.object({
  isDone: z.boolean(),
  tasks: z.array(z.string()).optional(),
})

const ExtraBadgesSchema = z.object({
  'Welcome to the family': BadgeSchema.optional(),
  Shielded: BadgeSchema.optional(),
  Exploring: BadgeSchema.optional(),
})

const BrandDataSchema = z
  .object({
    extraBadges: ExtraBadgesSchema,
  })
  .catchall(z.array(z.string().uuid()))

export const CompletedTutorialsSchema = z
  .object({
    'wc-straighttalk': BrandDataSchema.optional(),
    'wc-tracfone': BrandDataSchema.optional(),
  })
  .strict()

export const SessionFullResponseSchema = z.object({
  sessionDefinitionType: z.string(),
  createdAt: z.number(),
  data: z.object({
    completedTutorials: z.string(),
  }),
  updatedAt: z.number(),
  expiresAt: z.string().nullable(),
  phoneNumber: z.string(),
  sessionId: z.string(),
})

export const SessionResponseSchema = z.object({
  data: z.array(SessionFullResponseSchema),
})

export const WrappedSessionResponseSchema = z.object({
  data: SessionFullResponseSchema,
  message: z.string().optional(),
})

export const safeParseCompletedTutorials = (jsonString) => {
  try {
    const parsed = JSON.parse(jsonString)
    return CompletedTutorialsSchema.parse(parsed)
  } catch (error) {
    throw new Error('Invalid completedTutorials format')
  }
}

export const safeStringifyCompletedTutorials = (data) => {
  try {
    const validated = CompletedTutorialsSchema.parse(data)
    return JSON.stringify(validated)
  } catch (error) {
    throw new Error('Invalid data structure for completedTutorials')
  }
}
